import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const PlayCircleSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default PlayCircleSVG;
